<template>
    <article-create-edit-form />
</template>

<script>
import ArticleCreateEditForm from './components/ArticleCreateEditForm.vue';

export default {
    components:{
        ArticleCreateEditForm
    }
}
</script>
